import React from "react";
import { I18nextProvider } from "react-i18next";
import { i18n } from "../locales/i18next";
import { DeleteSavedSearchModal, Props } from "./DeleteSavedSearchModal";

export const DeleteSavedSearchModalContainer = ({
  isOpen,
  closeModal,
  savedSearchId,
  savedSearchName,
  category,
  onCancel = closeModal,
  onDelete,
}: Props) => (
  <I18nextProvider i18n={i18n}>
    <DeleteSavedSearchModal
      isOpen={isOpen}
      closeModal={closeModal}
      savedSearchId={savedSearchId}
      savedSearchName={savedSearchName}
      category={category}
      onDelete={onDelete}
      onCancel={onCancel}
    />
  </I18nextProvider>
);
